import React, { PropTypes, Component } from 'react'
import style from './style.css';

class SectionTitle extends Component {

    render() {
        return (
            <h2 className={ style.title }>{ this.props.title }</h2>
        )
    }
}

export default SectionTitle



// WEBPACK FOOTER //
// ./src/components/pagescreen/pagetitle/index.js